module.exports = __webpack_public_path__ + "static/img/nav_logo.png";